import(/* webpackMode: "eager" */ "/vercel/path0/apps/game/app/error.tsx");
